import { IState } from '../../../store';

export const isShowDemolishedProgramDisclaimer = (state: IState) => {
  return state.offerData.offer.demolishedInMoscowProgramm;
};
